import { Search } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Card, CardContent, Container, FormControl, Grid, MenuItem, Select } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import OpdCard from 'examples/Cards/OpdCard'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'

const Opd = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [namaOpd, setNamaOpd] = useState('')
    const [jenis, setJenis] = useState('')

    useEffect(() => {
        reqOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqOpd = () => {
        setLoading(true)
        postDataWithResponse(
            '/opd/filter',
            {
                jenis: jenis,
                nama: namaOpd,
            },
            null,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    const submit = (e) => {
        e.preventDefault();
        reqOpd()
    }

    return (
        <Container sx={{ my: 10 }}>
            <ArgonBox mt={2}>
                <Grid container spacing={2} my={2}>
                    <Grid item xs={12} xl={12}>
                        <ArgonTypography>DAFTAR OPD</ArgonTypography>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mt={2}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} component='form' onSubmit={submit} mt={1}>
                            <Grid item xs={12} xl={5}>
                                <ArgonBox mb={1}>
                                    <ArgonInput
                                        type="text"
                                        size="medium"
                                        value={namaOpd}
                                        placeholder="Nama SKPD"
                                        onChange={(e) => { setNamaOpd(e.target.value) }}
                                        autoComplete='off'
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} xl={5}>
                                <ArgonBox mb={1}>
                                    <FormControl fullWidth>
                                        {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                                        <Select
                                            placeholder="Select year"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={jenis}
                                            onChange={(e) => {
                                                setJenis(e.target.value)
                                            }}
                                        >
                                            <MenuItem key={0} value={'opd'}>DINAS</MenuItem>
                                            <MenuItem key={1} value={'kecamatan'}>KECAMATAN</MenuItem>
                                        </Select>
                                    </FormControl>
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} xl={2}>
                                <LoadingButton
                                    fullWidth
                                    color='info'
                                    variant='contained'
                                    size="small"
                                    startIcon={<Search />}
                                    type='submit'
                                    loading={loading}
                                    sx={{
                                        verticalAlign: 'bottom'
                                    }}
                                >
                                    Search
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </ArgonBox>
            <ArgonBox mt={2}>
                <Grid container spacing={4} component='form' onSubmit={submit} mt={1}>
                    {
                        data.map((dt, index) => (
                            <Grid item xs={12} xl={6} key={index}>
                                <OpdCard
                                    namaOpd={dt.nama_pd}
                                    jenis={dt.ket}
                                    kepalaOpd={dt.nama_pimpinan}
                                    alamat={dt.alamat}
                                    email={dt.email}
                                    telp={dt.tlp}
                                />
                            </Grid>
                        ))
                    }

                </Grid>
            </ArgonBox>
        </Container>
    )
}

export default Opd